import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home } from 'lucide-react';

const Header = ({ showBackButton = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Left side - Back button (on inner pages) */}
          <div className="flex items-center">
            {!isHomePage && showBackButton && (
              <Button
                onClick={() => navigate(-1)}
                variant="outline"
                size="sm"
                className="border-2 border-[#2F5E96] text-[#2F5E96] hover:bg-[#2F5E96]/10 font-medium"
                data-testid="header-back-button"
              >
                <Home className="w-4 h-4 mr-2" />
                Back
              </Button>
            )}
          </div>

          {/* Right side - Logo */}
          <img 
            src="https://customer-assets.emergentagent.com/job_resin-quote-calc/artifacts/0yxgnasw_IMG_8077.jpeg" 
            alt="Ox Resin ProBound Logo" 
            className="h-10 md:h-14 object-contain cursor-pointer"
            onClick={() => navigate('/')}
            data-testid="company-logo"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;